import {IconButton, ListItem, ListItemText, useTheme} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {type Alias} from 'client';

export const CompanyAliasListRow = ({alias, removeAlias}: {alias: Alias; removeAlias: (alias: Alias) => void}) => {
  const theme = useTheme();

  return (
    <ListItem
      slotProps={{
        root: {
          style: {backgroundColor: theme.palette.action.hover, borderRadius: 4, margin: 2},
        },
      }}
      secondaryAction={
        <IconButton
          edge="end"
          aria-label="delete"
          size="small"
          color="secondary"
          data-testid={`delete-alias-button-${alias.alias}`}
        >
          <DeleteIcon
            onClick={() => {
              removeAlias(alias);
            }}
          />
        </IconButton>
      }
    >
      <ListItemText primary={alias.alias} secondary={`${alias.externalSystem}`} />
    </ListItem>
  );
};
